import '../../App.css';
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import {Link} from 'react-router-dom';
import { 
  Grid , 
  Card, 
  CardContent, 
  Typography, 
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,  
} from '@mui/material';
import Iconify from '../../common/Iconify/Iconify';
import ScatterSaveToDatabase from '../Scatter/ScatterSaveToDatabase';

function ScatterPlot() {

  //This code helps to scroll to the top when the screen is open
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    /// To activate Dialog instead of modal/// <--- Chato: cambiar el codigo para q grabe toda la info a la base de datos

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
    
    const handleClose = () => {
      setOpen(false);
    };
  ///////////////////////////////////////////  


  

  const canvasRef = useRef(null);
  const [points, setPoints] = useState([]);
  const [activePoint, setActivePoint] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    redraw(ctx);
  }, [points]);

  const drawAxes = (ctx) => {
    const canvas = canvasRef.current;
    ctx.beginPath();
    ctx.strokeStyle = 'rgb(146, 209, 223)';
    ctx.moveTo(canvas.width / 2, 0);
    ctx.lineTo(canvas.width / 2, canvas.height);
    ctx.moveTo(0, canvas.height / 2);
    ctx.lineTo(canvas.width, canvas.height / 2);
    ctx.stroke();
    ctx.fillStyle = 'rgb(146, 209, 223)';
    ctx.fillText('Negative impact', 10, canvas.height / 2 + 12);
    ctx.rotate(Math.PI / -2);
    ctx.fillText('Less Common', -canvas.width + 10, canvas.width / 2 - 8);
    ctx.rotate(Math.PI / 2);
    ctx.fillText('Positive impact', canvas.width - 75, canvas.height / 2 - 8);
    ctx.rotate(Math.PI / -2);
    ctx.fillText(
      'More Common',
      -canvas.width + canvas.width - 75,
      canvas.width / 2 + 12
    );
    ctx.rotate(Math.PI / 2);
  };

  const drawPoint = (ctx, x, y, goaltext) => {
    const canvas = canvasRef.current;
    ctx.fillStyle = 'rgb(146, 209, 223)';
    ctx.beginPath();
    ctx.arc(
      x + canvas.width / 2,
      canvas.height / 2 - y,
      5,
      0,
      2 * Math.PI
    );
    ctx.fill();
    ctx.fillText(goaltext, x + canvas.width / 2 + 10, canvas.height / 2 - y);
  };

  const redraw = (ctx) => {
    const canvas = canvasRef.current;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawAxes(ctx);
    for (let i = 0; i < points.length; i++) {
      const { x, y, goaltext } = points[i];
      drawPoint(ctx, x, y, goaltext);
    }
  };

/////// To activate modal after drawing dots section starts//////
const [dialogOpen, setDialogOpen] = useState(false);
const [inputValue, setInputValue] = useState('');
const [clickedCoordinates, setClickedCoordinates] = useState({ x: 0, y: 0 });

const handleDialogOpen = () => {
  setInputValue('');
  setDialogOpen(true);
}
const handleDialogClose = () => {
  setDialogOpen(false);
};
const handleInputChange = (e) => {
  setInputValue(e.target.value);
};


const handleDialogConfirm = (e) => {
  const canvas = canvasRef.current;
  const canvasRect = canvas.getBoundingClientRect();
  const x = e.clientX - canvasRect.left - canvas.width / 2;
  const y = canvas.height / 2 - (e.clientY - canvasRect.top);

  if (inputValue.trim()) {
    const newDot = { ...clickedCoordinates, title: inputValue };
    setSavedDots((prevDots) => [...prevDots, newDot]);

    // Use the correct coordinates for drawing the point on the canvas
    setPoints((prevPoints) => [...prevPoints, { ...clickedCoordinates, goaltext: inputValue }]);

    redraw(canvasRef.current.getContext('2d'));
    handleDialogClose();
  }
};
/////// To activate modal after drawing dots section ends//////

  

  ///////section for clicking and storing coordinates //////
  const handleCanvasClick = async (e) => {
    const canvas = canvasRef.current;
    const canvasRect = canvas.getBoundingClientRect();
    const x = e.clientX - canvasRect.left - canvas.width / 2;
    const y = canvas.height / 2 - (e.clientY - canvasRect.top);

    setClickedCoordinates({ x, y }); // Store the clicked coordinates

    handleDialogOpen();
  };


  ///////section for cleaning all dots //////
  const handleClearDots = () => {
    setPoints([]);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    redraw(ctx); // Clear the canvas
    window.location.reload();
  };


  const [savedDots, setSavedDots] = useState([]);  ///// <--- to store and place dots in the form (modal)


  const toDatabaseButtonRef = useRef(null);


 

  return (
 
<>
  

  <Card 
          sx={{ bgcolor: '#B3B8CD',
                minWidth: '300px',
                padding: '1rem 3%',
                marginX: '5%',
                marginTop: '2rem'
              }} >

      <CardContent>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Typography variant="h4" color='black'>Creating a Strategy or Goal ...</Typography>
            </Grid>
            <Grid item> 
              <Typography variant="body1" color='white' fontSize={11}>Please click on the canvas where you think your strategy or action in your 2050Commitment is located today</Typography><br />
              <Typography variant="body1" color='white' fontSize={11}>There is no right or wrong answer here. Your picked location should be based on your current interpretation of how much IMPACT ("X" axis), and how COMMON ("Y" axis) is your solution / action / strategy today. </Typography><br />
              <Typography variant="text1" color='white' fontSize={11}>When mapping this, think about your city or community, compared to what you consider peer cities / communities</Typography>
            </Grid>
          </Grid>
      </CardContent>
    </Card>


{/*   ////////////Scatter Plot area starts here///////////////   */}
    <Grid marginX='5%' marginTop='1.5rem' textAlign='center'>
    <Card
            sx={{
              bgcolor: '#231E39',
              paddingTop: "2rem",
            
            }}
        >
      <CardContent>
        <Grid container alignItems='space-between' flexDirection='row'>
        <Grid item xs={12} flexDirection='row' alignItems='center' >
              <Typography variant="body1" color='white' fontSize={11} paddingBottom='1.5rem'> Upon mapping your strategies, click on the button below</Typography>
              <Button                 
                onClick={handleClickOpen}
                sx={{
                  paddingRight: '1.5rem',
                  marginBottom: '1rem',
                  marginRight: '1.5rem',
                  border: '1px solid var(--main-color)',
                  color: 'var(--main-color)',
                  alignContent: 'center',
                  width: '100%'                                  
                }}
                startIcon={<Iconify icon="ant-design:dot-chart-outlined"/>}
                >
                Save all dots to Database
              </Button>
              <Typography variant="body1" color='gray' fontSize={11} paddingBottom='1.5rem'> 
                Once dots are stored, you can edit them and add more details in your profile page</Typography>
              <ScatterSaveToDatabase open={open} handleClose={handleClose} savedDots={savedDots}/>
          </Grid>
          <Grid 
          sx={{
            padding: '0.5rem',
            margin: '0 auto',
          }}>

              {/* Plotting the Canvas for the Scatterplot */}
              <Grid alignItems='center' justifyContent="center">    

                <canvas
                id="scatter"
                className="scatter"
                ref={canvasRef}
                width={500}
                height={500}
                onClick={handleCanvasClick}
                ></canvas>

              </Grid>  
          </Grid>

          
        </Grid>
      </CardContent>
        <Grid marginX='3%'>
              <Button                 
                onClick={handleClearDots}
                sx={{
                  paddingRight: '1.5rem',
                  marginBottom: '1rem',
                  marginRight: '1.5rem',
                  border: '1px solid var(--main-color)',
                  color: 'var(--main-color)',
                  alignContent: 'center',
                  width: '100%'                                     
                }}
                startIcon={<Iconify icon="mdi:backspace-outline"/>}
                >
                Clear all dots 
              </Button>
        </Grid>
    </Card>
    </Grid>
{/*   ////////////Scatter Plot area ends here///////////////   */}
  

<Dialog open={dialogOpen} onClose={handleDialogClose}>
  <DialogTitle fontSize={15}> Please choose a name for your strategy</DialogTitle>
  <Typography variant="body" color='gray' fontSize={11} margin='3rem'>Try to limit this to 10 words, more details can be added in your profile page</Typography>
  <DialogContent>
    <TextField
        autoFocus
        margin="dense"
        id="name"
        label="Strategy Name"
        type="text"
        fullWidth
        value={inputValue}
        onChange={handleInputChange}
      />
  </DialogContent>
  <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDialogConfirm} color="primary">
            Confirm
          </Button>
        </DialogActions>
  </Dialog>

</>
    
  );
}

const canvas = document.createElement('canvas');
canvas.id = 'scatter';

export default ScatterPlot;
